import { Box, Grid2 as Grid, TextField } from "@mui/material";
import { FC } from "react";
import { useFormContext, useWatch, Controller } from "react-hook-form";
import { DatePickerField, NumberTextField } from "src/shared/components";
import { EOrganizationValue } from "src/shared/types/companies.types";
import { messages } from "src/shared/utils/hookFormRules";
import { IPartnerFormValues } from "../../model/types";
import { IEditPartnerFormValues } from "../../model/types/partner";

export const License: FC<{ isEdit?: boolean }> = ({ isEdit = false }) => {
  const { control } = useFormContext<
    IPartnerFormValues | IEditPartnerFormValues
  >();
  const organizationForm = useWatch({
    control,
    name: "partner.organization_form",
  });

  const isIndividualEntrepreneur =
    organizationForm === EOrganizationValue.IndividualEntrepreneur;

  return (
    <Box>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
          <Controller
            control={control}
            name="license.number"
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <NumberTextField
                fullWidth
                {...field}
                onChange={(v) => field.onChange(String(v))}
                inputRef={ref}
                label="№ свидетельства"
                error={!!error}
                helperText={error?.message}
                inputProps={{
                  maxLength: 30,
                  readOnly: isEdit && isIndividualEntrepreneur,
                }}
              />
            )}
            rules={{
              required: isIndividualEntrepreneur
                ? messages.required
                : undefined,
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
          <Controller
            name="license.issued_date"
            control={control}
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <DatePickerField
                {...field}
                inputRef={ref}
                disableFuture
                error={error}
                label="Выдано"
                placeholder="dd.mm.yyyy"
                slotProps={{ field: { clearable: true } }}
              />
            )}
            rules={{
              required: isIndividualEntrepreneur
                ? messages.required
                : undefined,
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
          <Controller
            control={control}
            name="license.issued_by"
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <TextField
                fullWidth
                {...field}
                inputRef={ref}
                label="Кем"
                error={!!error}
                helperText={error?.message}
              />
            )}
            rules={{
              required: isIndividualEntrepreneur
                ? messages.required
                : undefined,
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
